const bookingDueTodayReducer = (state = false, action) => {
	switch(action.type){
	case 'BOOKINGDUETODAY':	
		return true;
	default:
		return state;
	}
}

export default bookingDueTodayReducer;